(function () {
  var ATTRIBUTE = "_exp_purchase_default";
  var EXPERIMENT = "purchase_default";
  var SESSION_KEY = "ghia_exp_seen";

  function controller() {
    return document.querySelector("product-details-controller");
  }

  function observedArm() {
    var scope = controller();
    if (!scope) return null;

    var subscribe = scope.querySelector("#subscribe-purchase");
    var oneTime = scope.querySelector("#one-time-purchase");
    if (!subscribe) return null;
    if (!oneTime) return "subscription_only";

    return subscribe.checked ? "subscribe_default" : "onetime_default";
  }

  function handle() {
    var ctx = window.GhiaCtx || {};
    return ctx.handle || "";
  }

  function reportExposure(arm) {
    var seen;
    try {
      seen = sessionStorage.getItem(SESSION_KEY);
    } catch (e) {
      seen = null;
    }

    var signature = EXPERIMENT + ":" + handle() + ":" + arm;
    if (seen === signature) return;

    try {
      sessionStorage.setItem(SESSION_KEY, signature);
    } catch (e) {}

    if (typeof window.ghiaTrack === "function") {
      window.ghiaTrack("experiment_exposure", {
        experiment_name: EXPERIMENT,
        experiment_arm: arm,
      });
    }
  }

  function tagCart(arm) {
    var attributes = {};
    attributes[ATTRIBUTE] = arm + "|" + handle();

    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: attributes }),
      }).catch(function () {});
    } catch (e) {}
  }

  function start() {
    var arm = observedArm();
    if (!arm) return;

    reportExposure(arm);

    var tagged = false;
    document.addEventListener("cart:updated", function () {
      if (tagged) return;
      var current = observedArm() || arm;
      tagged = true;
      tagCart(current);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
